import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';

const CategoryTabs = ({ activeCategory = 'all', onSelect, categories = [] }) => {
	if (typeof onSelect !== 'function' || !Array.isArray(categories)) return null;

	const normalizedCategories = Array.from(new Set(['all', ...categories.map(String)]));

	return (
		<div className="vayu-category-tabs">
			{normalizedCategories.map((cat) => {
				const label = cat === 'all'
					? __('All', 'vayu-blocks')
					: cat.charAt(0).toUpperCase() + cat.slice(1);

				return (
					<button
						key={cat}
						type="button"
						onClick={() => onSelect(cat)}
						aria-pressed={activeCategory === cat}
						className={`vayu-category-tab ${activeCategory === cat ? 'is-active' : ''}`}
					>
						{label}
					</button>
				);
			})}
		</div>
	);
};

CategoryTabs.propTypes = {
	activeCategory: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	categories: PropTypes.array.isRequired,
};

export default CategoryTabs;
